import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';
import { kioskCartFunnelBottomPaddingProperty, kioskCartFunnelTopPaddingProperty } from './kiosk-cart-funnel-top-padding';

export const KIOSKCARTFUNNELFORMBLOCK_LEGACY_FIELD_ORDER = [
  "title",
  "top_padding",
  "bottom_padding",
  "fill_height"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  kioskCartFunnelFormBlockDescriptor: _generatedKioskCartFunnelFormBlockDescriptor,
  kioskCartFunnelFormBlockBlocDefinition,
  kioskCartFunnelFormBlockDashboardLayout,
  kioskCartFunnelFormBlockConfig,
  kioskCartFunnelFormBlockResolveConfig,
  kioskCartFunnelFormBlockProperties,
} = doodBlockConfig(
  {
    name: "Kiosk Cart funnel / Form",
    componentType: 'KioskCartFunnelFormBlockComponent',
    category: 'kiosk',
    description: "Kiosk Cart funnel / Form.",
    keywords: [],
    allowedIn: [
      { bloc: 'KioskCartFunnelPageComponent', slot: 'body' },
    ],


    sharedFields: {}
,
    slots: [
      {
        key: 'items',
        name: "pages.blocks.kiosk-cart-funnel-form.items.label",
        accept: 'explicitOnly',
        allowedTypes: ["KioskCartFunnelRadioItemBlock", "KioskCartFunnelPagerBlock", "KioskCartFunnelInputTextBlock", "KioskCartFunnelTextItemBlock", "KioskCartFunnelOnBehalfFieldBlock", "CartFunnelSeatCountItemBlock", "CartFunnelMinimumAgeItemBlock", "TextBlock", "FrameBlock", "ImageFullWidthBlock", "ImageVariableWidthBlock", "ImageAndTextBlock"],
        slotItemFormat: 'ids',
      }
    ]
  },

  () => ({
    title: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.kiosk-cart-funnel-form.title.label",
        help: "pages.blocks.kiosk-cart-funnel-form.title.help",
      }
    }),
    top_padding: kioskCartFunnelTopPaddingProperty('kiosk-cart-funnel-form'),
    bottom_padding: kioskCartFunnelBottomPaddingProperty('kiosk-cart-funnel-form'),
    fill_height: propertyValue({
      type: 'checkbox',
      value: true,
      options: {
        label: "pages.blocks.kiosk-cart-funnel-form.fill-height.label",
        help: "pages.blocks.kiosk-cart-funnel-form.fill-height.help",
      },
    }),
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.kiosk-cart-funnel-form.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.kiosk-cart-funnel-form.fieldset.form.label",
            fields: ["title", "fill_height", "top_padding", "bottom_padding", "items"],
          },
        ],
      },
    ],
  })
);

export function kioskCartFunnelFormBlockDescriptor(): IBlockDescriptor;
export function kioskCartFunnelFormBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function kioskCartFunnelFormBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedKioskCartFunnelFormBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedKioskCartFunnelFormBlockDescriptor, kioskCartFunnelFormBlockProperties, fieldOrder);
}

export {
  kioskCartFunnelFormBlockBlocDefinition,
  kioskCartFunnelFormBlockDashboardLayout,
  kioskCartFunnelFormBlockProperties,
  kioskCartFunnelFormBlockConfig,
  kioskCartFunnelFormBlockResolveConfig,
};

export type KioskCartFunnelFormBlockConfig = typeof kioskCartFunnelFormBlockConfig;
